<div class="flex align-items-center justify-content-center overflow-hidden" style="height: 80vh;">
    <div class="flex flex-column align-items-center justify-content-center">
        <div style="border-radius:56px; padding:0.2rem; background: linear-gradient(180deg, #262863 10%, rgba(33, 150, 243, 0) 30%);">
            <div class="w-full surface-card py-8 px-5 sm:px-8 flex flex-column align-items-center " style="border-radius:53px; text-align: center;">
                <span class="font-bold text-3xl">{{code}}</span>
                <h1 class="text-900 font-bold text-2xl lg:text-5xl mb-2">{{title}}</h1>
                <div class="text-600 mb-5">{{subtitle}}</div>
            </div>
        </div>
    </div>
</div>